import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SkeletonService {
    public skeletonVisibleSubject = new BehaviorSubject(false);
    private skeletonMinimumVisibilityTimeInMs = 600;
    private skeletonTimeoutEnded: boolean;
    private isWaitingToTurnoffSkeleton: boolean;
    private skeletonTimeout: NodeJS.Timeout;
    private afterTurnOffCallback: () => void;

    initialize() {
        clearTimeout(this.skeletonTimeout);
        this.skeletonVisibleSubject.next(false);
        this.skeletonTimeoutEnded = false;
        this.isWaitingToTurnoffSkeleton = false;
        this.afterTurnOffCallback = undefined;
    }

    turnOnSkeleton() {
        if (!this.skeletonVisibleSubject.value) {
            this.skeletonTimeoutEnded = false;
            if (this.skeletonTimeout) {
                clearTimeout(this.skeletonTimeout);
            }
            this.setSkeletonTimeout();
            this.skeletonVisibleSubject.next(true);
        }
    }

    turnOffSkeleton(callback?: () => void) {
        if (this.skeletonTimeoutEnded) {
            this.skeletonVisibleSubject.next(false);
            if (callback) {
                callback();
            }
        } else {
            this.isWaitingToTurnoffSkeleton = true;
            this.afterTurnOffCallback = callback;
        }
    }

    get isSkeletonVisible() {
        return this.skeletonVisibleSubject.value;
    }

    private setSkeletonTimeout() {
        this.skeletonTimeout = setTimeout(() => {
            this.skeletonTimeoutEnded = true;

            if (this.isWaitingToTurnoffSkeleton) {
                this.isWaitingToTurnoffSkeleton = false;
                this.skeletonVisibleSubject.next(false);
                if (this.afterTurnOffCallback) {
                    this.afterTurnOffCallback();
                }
            }
        }, this.skeletonMinimumVisibilityTimeInMs);
    }
}
